"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Pendo = function Pendo(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 233.262,
    style: {
      fill: "#265b58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.582 232.053c.45 5.923.68 11.908.68 17.947 0 128.827-104.435 233.262-233.262 233.262-10.734 0-21.3-.725-31.649-2.13l-.47-.58-92.81-113.198 252.682-230.36 104.829 95.059",
    fill: "#194140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382.151 410.32-72.237-28.207H154.435c-20.206 0-36.586-16.38-36.586-36.587V154.397c0-20.206 16.38-36.586 36.586-36.586h191.13c20.206 0 36.586 16.38 36.586 36.586V410.32z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.649 275.729c9.433 0 17.108-7.754 17.108-17.283 0-9.53-7.675-17.282-17.108-17.282-9.434 0-17.109 7.752-17.109 17.282 0 9.53 7.675 17.283 17.109 17.283zM200.323 275.729c9.434 0 17.109-7.754 17.109-17.283 0-9.53-7.675-17.282-17.109-17.282s-17.108 7.752-17.108 17.282c0 9.53 7.674 17.283 17.108 17.283z",
    fill: "#22c488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.974 275.729c9.434 0 17.109-7.754 17.109-17.283 0-9.53-7.675-17.282-17.109-17.282s-17.108 7.752-17.108 17.282c0 9.53 7.674 17.283 17.108 17.283z",
    fill: "#035c5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.974 327.576c9.434 0 17.109-7.753 17.109-17.283 0-9.53-7.675-17.282-17.109-17.282s-17.108 7.752-17.108 17.282c0 9.53 7.674 17.283 17.108 17.283zM251.65 327.576c9.434 0 17.108-7.753 17.108-17.283 0-9.53-7.674-17.282-17.108-17.282-9.434 0-17.109 7.752-17.109 17.282 0 9.53 7.675 17.283 17.109 17.283z",
    fill: "#22c488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.32 293.011c-9.433 0-17.108 7.754-17.108 17.283 0 9.53 7.675 17.282 17.108 17.282 9.437 0 17.114-7.752 17.114-17.282 0-9.53-7.677-17.283-17.114-17.283zM217.432 163.393c-4.725 0-8.555 3.87-8.555 8.641v25.924c0 4.772 3.83 8.641 8.555 8.641 4.724 0 8.554-3.869 8.554-8.64v-25.925c0-4.772-3.83-8.64-8.554-8.64z",
    fill: "#035c5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.501 189.317h-9.527v8.641c0 9.367-7.836 17.282-17.108 17.282-9.273 0-17.109-7.915-17.109-17.282v-8.641H234.54v8.641c0 9.367-7.836 17.282-17.108 17.282-9.273 0-17.126-7.915-17.126-17.282v-8.641h-9.523c-13.629 0-24.677 11.16-24.677 24.927v9.638h171.072v-9.638c0-13.767-11.048-24.927-24.677-24.927z",
    fill: "#22c488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.311 197.958c0 4.772 3.83 8.641 8.555 8.641 4.724 0 8.554-3.869 8.554-8.64v-25.925c0-4.772-3.83-8.64-8.554-8.64-4.725 0-8.555 3.868-8.555 8.64v25.924z",
    fill: "#035c5a"
  }));
};
var _default = exports["default"] = Pendo;